import {
  IconArrowsJoin2,
  IconCalculator,
  IconCategoryPlus,
  IconCircleDashedX,
  IconCircleSquare,
  IconCursorText,
  IconFilter,
  IconFilterCode,
  IconHandFinger,
  IconHelp,
  IconLetterCase,
  IconReorder,
  IconZoomReplace,
} from "@tabler/icons-react";
import type { TransformerTypeConfig } from "@/types/configs";

// Re-export for backward compatibility
export type { TransformerTypeConfig };

export const transformers: Record<string, TransformerTypeConfig> = {
  select: {
    id: "select",
    label: "Select",
    icon: IconHandFinger,
    tooltip: "Select specific columns",
  },
  calculate: {
    id: "calculate",
    label: "Calculate",
    icon: IconCalculator,
    tooltip: "Calculate new columns",
  },
  where: {
    id: "where",
    label: "Where",
    icon: IconFilter,
    tooltip: "Filter rows",
  },
  where_sql: {
    id: "where_sql",
    label: "SQL",
    icon: IconFilterCode,
    tooltip: "Filter rows with SQL",
  },
  sort: {
    id: "sort",
    label: "Sort",
    icon: IconReorder,
    tooltip: "Sort rows",
  },
  column_type: {
    id: "column_type",
    label: "Type",
    icon: IconCircleSquare,
    tooltip: "Change column data types",
  },
  column_name: {
    id: "column_name",
    label: "Rename",
    icon: IconCursorText,
    tooltip: "Rename columns",
  },
  fill_missing: {
    id: "fill_missing",
    label: "Missing",
    icon: IconCircleDashedX,
    tooltip: "Handle missing values",
  },
  find_replace: {
    id: "find_replace",
    label: "Replace",
    icon: IconZoomReplace,
    tooltip: "Replace values",
  },
  upper_lower: {
    id: "upper_lower",
    label: "Case",
    icon: IconLetterCase,
    tooltip: "Change case of column values",
  },
  group: {
    id: "group",
    label: "Group",
    icon: IconCategoryPlus,
    tooltip: "Group rows",
  },
  join: {
    id: "join",
    label: "Join",
    icon: IconArrowsJoin2,
    tooltip: "Join datasets",
  },
  default: {
    id: "unknown",
    label: "Unknown",
    icon: IconHelp,
    tooltip: "Unknown transformer",
  },
};
